import { cva, VariantProps } from 'class-variance-authority';

export const dialogVariants = cva('tw:min-h-0 tw:max-h-screen', {
  variants: {
    mode: {
      default: '',
      sheet: '',
      'sheet-right': 'tw:animate-slide-in-from-right',
      'sheet-bottom': '',
      'sheet-left': '',
      'sheet-top': '',
    },
  },
  defaultVariants: {
    mode: 'default',
  },
});

export type DialogVariants = VariantProps<typeof dialogVariants>;
